import type { ModalConfig } from "./types";

export const taskModalsModalUrlConfig = {
  // Task Modals
  "tasks-detail": {
    modalId: "tasks-detail",
    entityName: "tasks",
    singularParam: "taskId",
    pluralParam: "tasksId",
    displayName: "Task",
  },
  "create-tasks": {
    modalId: "create-tasks",
    entityName: "tasks",
    singularParam: "taskId",
    pluralParam: "tasksId",
    displayName: "Task",
  },
  "edit-tasks": {
    modalId: "edit-tasks",
    entityName: "tasks",
    singularParam: "taskId",
    pluralParam: "tasksId",
    displayName: "Task",
  },
} as const satisfies Record<string, ModalConfig>;
